import React from 'react';
import { ISVGType } from './SVGType';

const RightArrowIconSVG: React.FC<ISVGType> = (props) => {
  const { height = 42, width = 42, color = "#AFB4C0" } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 42 42"
      fill="none"
    >
      <circle
        cx="21"
        cy="21"
        r="21"
        fill="#E7E7E7"
      />
      <path
        d="M23.0394 20.9913C22.6335 20.5901 22.2593 20.2229 21.8886 19.8522C20.4082 18.373 18.9371 16.8867 17.4485 15.4168C16.8514 14.8279 16.8643 13.9411 17.4051 13.3756C17.9834 12.7703 18.9887 12.9733 19.4498 13.4437C21.5906 15.6256 23.7479 17.7923 25.9369 19.9261C26.4941 20.4692 26.5363 21.4793 25.9427 22.0588C23.7538 24.1926 21.5953 26.3581 19.4556 28.5424C18.9207 29.0878 17.9306 29.1805 17.4133 28.6303C16.8831 28.0673 16.8361 27.1769 17.4661 26.554C19.3184 24.7252 21.1519 22.8776 23.0382 20.9924L23.0394 20.9913Z"
        fill={color}
      />
    </svg>
  );
};

export default RightArrowIconSVG;
